// extracted by mini-css-extract-plugin
export default {"tooltip":"BW-z","arrow":"CW-z"};